import React, { useState } from 'react';
import { ArrowRight, Heart, HandHeart } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
import { useDonate } from '../donate/DonateContext';
import { MembershipDialog } from './MembershipDialog';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from './ui/dialog';

const Hero = () => {
  const { t } = useLanguage();
  const { openDonate } = useDonate();
  const [comingSoon, setComingSoon] = useState(false);
  const [memberOpen, setMemberOpen] = useState(false);

  return (
    <section id="home" className="jbss-hero jbss-hero-plain">
      <div className="jbss-hero-decor" />
      <div className="jbss-hero-content">
        <h1 className="jbss-hero-title">{t('hero.title')}</h1>
        <p className="jbss-hero-sub">{t('hero.subtitle')}</p>

        <div id="about" className="jbss-hero-about">
          <p className="jbss-hero-about-text">{t('about.body')}</p>
        </div>

        <div className="jbss-hero-cta">
          <button className="jbss-btn jbss-btn-navy" onClick={() => setComingSoon(true)} data-testid="hero-learn-more">
            <span>{t('common.learnMore')}</span>
            <ArrowRight size={16} />
          </button>
          <button className="jbss-btn jbss-btn-outline" onClick={() => setMemberOpen(true)} data-testid="hero-volunteer">
            <HandHeart size={16} />
            <span>{t('common.volunteer')}</span>
          </button>
          <button className="jbss-btn jbss-btn-gold" onClick={openDonate} data-testid="hero-donate">
            <Heart size={16} fill="currentColor" />
            <span>{t('nav.donate')}</span>
          </button>
        </div>
      </div>

      <Dialog open={comingSoon} onOpenChange={setComingSoon}>
        <DialogContent className="jbss-coming-soon-dialog" data-testid="coming-soon-dialog">
          <DialogHeader>
            <DialogTitle className="jbss-coming-soon-title">{t('common.comingSoon')}</DialogTitle>
            <DialogDescription className="jbss-coming-soon-msg">{t('common.comingSoonMsg')}</DialogDescription>
          </DialogHeader>
        </DialogContent>
      </Dialog>
      <MembershipDialog open={memberOpen} onOpenChange={setMemberOpen} />
    </section>
  );
};

export default Hero;
